import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.string.includes.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", [_vm._m(0), _c("div", {
    staticClass: "order-maincontent-data-value"
  }, [_vm.gettingAutoNotificationsHistoric.isPending ? _c("div", {
    staticClass: "text-italic"
  }, [_vm._v("Loading ...")]) : _vm._e(), _vm.gettingAutoNotificationsHistoric.items.length < 1 ? _c("div", [_vm._v("No sent found")]) : _vm._e(), _vm._l(_vm.gettingAutoNotificationsHistoric.items, function (notification) {
    return _c("div", {
      key: "com-history-" + notification.notificationType.type + "-" + notification.id,
      staticClass: "text-smaller mt-2 mb-2"
    }, [_c("div", {
      staticClass: "flex"
    }, [_c("div", {
      staticClass: "text-smaller ml-1"
    }, [_vm._v(" " + _vm._s(_vm._f("formatDateTime")(notification.sendDate)) + " ")])]), _c("div", {
      staticClass: "flex align-baseline gap-2"
    }, [_c("div", {
      staticClass: "badge --small neutral"
    }, [_vm._v("auto")]), _c("div", {
      staticClass: "text-bold"
    }, [_vm._v(_vm._s(notification.notificationType.label))]), _c("div", {
      staticClass: "text-smaller"
    }, [_vm._v("to " + _vm._s(notification.destinatorEmails.join(" & ")))])])]);
  })], 2)]), _c("div", [_vm._m(1), _c("div", {
    staticClass: "order-maincontent-data-value"
  }, _vm._l(_vm.gettingAutoNotificationsConfigs.items, function (config) {
    return _c("div", {
      key: "com-config-" + config.notificationType.type,
      staticClass: "flex text-smaller line-height-1_7r"
    }, [_c("div", [_vm._v(_vm._s(config.notificationType.label))]), _c("div", {
      staticClass: "flex ml-2"
    }, [_vm.autoNotificationTypes_paymentIds.includes(config.notificationType.type) && _vm.order.user.isPreventedFromPaymentLateNotifications ? [_c("div", {
      staticClass: "flex"
    }, [_c(VAlert, {
      staticClass: "--small-2",
      attrs: {
        dense: "",
        outlined: "",
        icon: "mdi-block-helper",
        color: "red",
        text: ""
      }
    }, [_vm._v(" Auto notifs about payment prevented on user config ")])], 1)] : !config.config ? [_c("div", {
      staticClass: "badge --small neutral mr-3"
    }, [_vm._v("default")]), config.notificationType.label != "Reminder pick-up stored at cellar" ? _c(VBtn, {
      staticClass: "dfwa-btn --small-2 secondary",
      attrs: {
        rounded: "",
        disabled: _vm.isAnyActionInProgress
      },
      on: {
        click: function click($event) {
          return _vm.confirmDefineAutoNotificationConfig(config.notificationType.type, "forceResend");
        }
      }
    }, [_c(VIcon, {
      staticClass: "fas fa-wrench mr-1",
      attrs: {
        size: "0.65rem"
      }
    }), _c(VIcon, {
      staticClass: "fas fa-long-arrow-alt-right mr-1",
      attrs: {
        size: "0.65rem"
      }
    }), _vm._v(" Resend tomorrow ")], 1) : _vm._e(), _c(VBtn, {
      staticClass: "dfwa-btn --small-2 secondary ml-1",
      attrs: {
        rounded: "",
        disabled: _vm.isAnyActionInProgress
      },
      on: {
        click: function click($event) {
          return _vm.confirmDefineAutoNotificationConfig(config.notificationType.type, "preventSend");
        }
      }
    }, [_c(VIcon, {
      staticClass: "fas fa-wrench mr-1",
      attrs: {
        size: "0.65rem"
      }
    }), _c(VIcon, {
      staticClass: "fas fa-long-arrow-alt-right mr-1",
      attrs: {
        size: "0.65rem"
      }
    }), _vm._v(" Prevent sents ")], 1)] : [_c("div", {
      staticClass: "badge --small warning mr-3"
    }, [config.config.isForceResend ? [_vm._v("Resend tomorrow")] : config.config.isPreventSend ? [_vm._v("Preventing sent")] : _vm._e()], 2), _c(VBtn, {
      staticClass: "dfwa-btn --small-2 secondary",
      attrs: {
        rounded: "",
        disabled: _vm.isAnyActionInProgress
      },
      on: {
        click: function click($event) {
          return _vm.confirmDeleteAutoNotificationConfig(config.config.id);
        }
      }
    }, [_c(VIcon, {
      staticClass: "fas fa-wrench mr-1",
      attrs: {
        size: "0.65rem"
      }
    }), _c(VIcon, {
      staticClass: "fas fa-long-arrow-alt-right mr-1",
      attrs: {
        size: "0.65rem"
      }
    }), _vm._v(" Default ")], 1)]], 2)]);
  }), 0)]), _c("Confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fa fa-history"
  }), _vm._v(" History ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fas fa-cogs"
  }), _vm._v(" Reccuring jobs settings ")]);
}];
render._withStripped = true;
export { render, staticRenderFns };